import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import VueGtag from 'vue-gtag'
import './plugins'

Vue.config.productionTip = false
Vue.use(VueGtag, {
    config: {
      id: 'G-BPSDD9T0HE'
    }
})

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
